import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

/* ------------------------------------------------------------------ *
 * BWF · Single comment — avatar + speech card, matching the rest.
 * `isMe` (bool) highlights the current user's own comments.
 * ------------------------------------------------------------------ */

const ORANGE = '#ff9800';
const LINE = '1px solid rgba(255,255,255,0.08)';
const LINE2 = '1px solid rgba(255,255,255,0.14)';

const initials = (u) => (u?.username ? u.username.slice(0, 2).toUpperCase() : '??');
const avatarUrl = (u) => {
  const p = u?.profile?.image;
  if (!p) return null;
  return p.startsWith('http') ? p : `${process.env.REACT_APP_API_URL_BASE}${p}`;
};

export default function Comment({ comment, user, isMe }) {
  const t = comment?.time || '';
  const date = t.split('T')[0];
  const time = t.split('T')[1] ? t.split('T')[1].substring(0, 5) : '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.375 }}>
      <Avatar src={avatarUrl(user)} sx={{
        width: 36, height: 36, fontSize: 13, fontWeight: 700, bgcolor: 'rgba(255,255,255,0.12)', flex: '0 0 auto',
        boxShadow: isMe ? `0 0 0 2px ${ORANGE}` : 'none',
      }}>{initials(user)}</Avatar>

      <Box sx={{
        flex: 1, minWidth: 0, background: '#1e1e1e', borderRadius: '12px',
        border: isMe ? '1px solid rgba(255,152,0,0.28)' : LINE, p: '11px 14px',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 1, mb: 0.625 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: isMe ? ORANGE : '#fff', display: 'flex', alignItems: 'center', gap: 0.875 }}>
            {user?.username || 'Unknown'}
            {isMe && (
              <Box component="span" sx={{ fontSize: 10, fontWeight: 700, letterSpacing: 0.5, color: ORANGE, border: LINE2, borderRadius: 999, px: 0.875, py: '1px' }}>YOU</Box>
            )}
          </Typography>
          <Typography sx={{ fontSize: 11, color: '#7a7a7a', whiteSpace: 'nowrap', flex: '0 0 auto' }}>{date} {time}</Typography>
        </Box>
        <Typography sx={{ fontSize: 14, color: '#dcdcdc', lineHeight: 1.5, whiteSpace: 'pre-wrap', textWrap: 'pretty' }}>
          {comment?.description}
        </Typography>
      </Box>
    </Box>
  );
}
